module.exports = __webpack_public_path__ + "static/img/coin_white.64d05e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin_white.png
// module id = 36
// module chunks = 1